module.exports = __webpack_public_path__ + "media/assets/img/video/underline-0a86b83640f4383c5667c96052ee8875.svg";